import { Action, creator } from 'src/config/rootAction';

import {
    ChangeValuesAssessmentAreaFieldActionArguments,
    ValuesAssessmentDomain,
} from '../models/weekTwo';

export const CHANGE_HOMEWORK_CONFIDENCE_RATING_VALUE = 'CHANGE_HOMEWORK_CONFIDENCE_RATING_VALUE';
export type ChangeHomeworkConfidenceRatingValueAction = Action<
    typeof CHANGE_HOMEWORK_CONFIDENCE_RATING_VALUE,
    number
>;
export const changeHomeworkConfidenceRatingValue = creator<
    ChangeHomeworkConfidenceRatingValueAction
>(CHANGE_HOMEWORK_CONFIDENCE_RATING_VALUE);

export const SUBMIT_HOMEWORK_CONFIDENCE_RATING_REQUESTED =
    'SUBMIT_HOMEWORK_CONFIDENCE_RATING_REQUESTED';
export type SubmitHomeworkConfidenceRatingRequestAction = Action<
    typeof SUBMIT_HOMEWORK_CONFIDENCE_RATING_REQUESTED,
    number
>;
export const submitHomeworkConfidenceRatingRequest = creator<
    SubmitHomeworkConfidenceRatingRequestAction
>(SUBMIT_HOMEWORK_CONFIDENCE_RATING_REQUESTED);

export const SUBMIT_HOMEWORK_CONFIDENCE_RATING_SUCCEEDED =
    'SUBMIT_HOMEWORK_CONFIDENCE_RATING_SUCCEEDED';
export type SubmitHomeworkConfidenceRatingSuccessAction = Action<
    typeof SUBMIT_HOMEWORK_CONFIDENCE_RATING_SUCCEEDED
>;
export const submitHomeworkConfidenceRatingSuccess = creator<
    SubmitHomeworkConfidenceRatingSuccessAction
>(SUBMIT_HOMEWORK_CONFIDENCE_RATING_SUCCEEDED);

export const SUBMIT_HOMEWORK_CONFIDENCE_RATING_FAILED = 'SUBMIT_HOMEWORK_CONFIDENCE_RATING_FAILED';
export type SubmitHomeworkConfidenceRatingFailAction = Action<
    typeof SUBMIT_HOMEWORK_CONFIDENCE_RATING_FAILED
>;
export const submitHomeworkConfidenceRatingFail = creator<SubmitHomeworkConfidenceRatingFailAction>(
    SUBMIT_HOMEWORK_CONFIDENCE_RATING_FAILED,
);

export const CHANGE_VALUES_ASSESSMENT_AREA_FIELD = 'CHANGE_VALUES_ASSESSMENT_AREA_FIELD';
export type ChangeValuesAssessmentAreaFieldAction = Action<
    typeof CHANGE_VALUES_ASSESSMENT_AREA_FIELD,
    ChangeValuesAssessmentAreaFieldActionArguments
>;
export const changeValuesAssessmentAreaField = creator<ChangeValuesAssessmentAreaFieldAction>(
    CHANGE_VALUES_ASSESSMENT_AREA_FIELD,
);

export const SUBMIT_VALUES_ASSESSMENTS_DATA_REQUESTED = 'SUBMIT_VALUES_ASSESSMENTS_DATA_REQUESTED';
export type SubmitValuesAssessmentsDataRequestAction = Action<
    typeof SUBMIT_VALUES_ASSESSMENTS_DATA_REQUESTED,
    ValuesAssessmentDomain[]
>;
export const submitValuesAssessmentsData = creator<SubmitValuesAssessmentsDataRequestAction>(
    SUBMIT_VALUES_ASSESSMENTS_DATA_REQUESTED,
);

export const SUBMIT_VALUES_ASSESSMENTS_DATA_SUCCEEDED = 'SUBMIT_VALUES_ASSESSMENTS_DATA_SUCCEEDED';
export type SubmitValuesAssessmentsDataSuccessAction = Action<
    typeof SUBMIT_VALUES_ASSESSMENTS_DATA_SUCCEEDED
>;
export const submitValuesAssessmentsDataSuccess = creator<SubmitValuesAssessmentsDataSuccessAction>(
    SUBMIT_VALUES_ASSESSMENTS_DATA_SUCCEEDED,
);

export const SUBMIT_VALUES_ASSESSMENTS_DATA_FAILED = 'SUBMIT_VALUES_ASSESSMENTS_DATA_FAILED';
export type SubmitValuesAssessmentsDataFailAction = Action<
    typeof SUBMIT_VALUES_ASSESSMENTS_DATA_FAILED
>;
export const submitValuesAssessmentsDataFail = creator<SubmitValuesAssessmentsDataFailAction>(
    SUBMIT_VALUES_ASSESSMENTS_DATA_FAILED,
);

export const FETCH_VALUES_ASSESSMENTS_DATA_REQUESTED = 'FETCH_VALUES_ASSESSMENTS_DATA_REQUESTED';
export type FetchValuesAssessmentsDataRequestAction = Action<
    typeof FETCH_VALUES_ASSESSMENTS_DATA_REQUESTED
>;
export const fetchValuesAssessmentsDataRequest = creator<FetchValuesAssessmentsDataRequestAction>(
    FETCH_VALUES_ASSESSMENTS_DATA_REQUESTED,
);

export const FETCH_VALUES_ASSESSMENTS_DATA_SUCCEEDED = 'FETCH_VALUES_ASSESSMENTS_DATA_SUCCEEDED';
export type FetchValuesAssessmentsDataSuccessAction = Action<
    typeof FETCH_VALUES_ASSESSMENTS_DATA_SUCCEEDED,
    ValuesAssessmentDomain[]
>;
export const fetchValuesAssessmentsDataSuccess = creator<FetchValuesAssessmentsDataSuccessAction>(
    FETCH_VALUES_ASSESSMENTS_DATA_SUCCEEDED,
);

export const FETCH_VALUES_ASSESSMENTS_DATA_FAILED = 'FETCH_VALUES_ASSESSMENTS_DATA_FAILED';
export type FetchValuesAssessmentsDataFailAction = Action<
    typeof FETCH_VALUES_ASSESSMENTS_DATA_FAILED
>;
export const fetchValuesAssessmentsDataFail = creator<FetchValuesAssessmentsDataFailAction>(
    FETCH_VALUES_ASSESSMENTS_DATA_FAILED,
);

export const RESET_AREA_ADDITIONAL_RATE = 'RESET_AREA_ADDITIONAL_RATE';
export type ResetAreaAdditionalRateAction = Action<typeof RESET_AREA_ADDITIONAL_RATE>;
export const resetAreaAdditionalRate = creator<ResetAreaAdditionalRateAction>(
    RESET_AREA_ADDITIONAL_RATE,
);

export type WeekTwoAction =
    | ChangeHomeworkConfidenceRatingValueAction
    | SubmitHomeworkConfidenceRatingRequestAction
    | SubmitHomeworkConfidenceRatingSuccessAction
    | SubmitHomeworkConfidenceRatingFailAction
    | ChangeValuesAssessmentAreaFieldAction
    | SubmitValuesAssessmentsDataRequestAction
    | SubmitValuesAssessmentsDataSuccessAction
    | SubmitValuesAssessmentsDataFailAction
    | FetchValuesAssessmentsDataRequestAction
    | FetchValuesAssessmentsDataSuccessAction
    | FetchValuesAssessmentsDataFailAction
    | ResetAreaAdditionalRateAction;
